<template>
  <div
    :class="{
      inner: sector === 'call_again' || sector === 'no_answer',
      innerDep: sector === 'deposits'
    }"
  >
    <!--    <div-->
    <!--      v-if="selectedMainTab === 'clients' && expand && expandToRight"-->
    <!--      style="display: flex; justify-content: space-between; margin-top: 8px"-->
    <!--    >-->
    <!--      <h6 class="stats-types-button" @click="changeStatsView()">-->
    <!--        {{ checkType() }}-->
    <!--      </h6>-->

    <!--      <label for="check-all-main">-->
    <!--        <input id="check-all-main" v-model="selectAll" type="checkbox" />-->
    <!--      </label>-->
    <!--    </div>-->

    <table class="table table-striped main-ms-table">
      <thead :style="background.mainBg">
        <tr
          :class="{
            forQuest:
              sector === 'questions' ||
              sector === 'sms' ||
              sector === 'questions_status',
            forCampaign: selectedTab === 'campaign'
          }"
          class="table-row-main"
        >
          <th
            v-for="key in Object.keys(typeOfKeys)"
            v-if="checkForFilters(key)"
            :key="key"
          >
            <div class="table-title" :class="{ active: lastSort === key }">
              <span
                @click="sort(key)"
                style="margin-right: 3px; cursor: pointer;"
              >
                <i class="fa fas fa-sort-amount-down"></i>
              </span>
              {{ typeOfKeys[key] }} | {{ sumTotalTitles(key) }}
            </div>
          </th>

          <th>
            <div style="display: flex; justify-content: center;">
              <div class="table-title " :class="{ active: !lastSort }">
                <span style="margin-right: 3px; cursor: pointer;">
                  <i
                    @click="sortByTot(expand)"
                    class="fa fas fa-sort-amount-down"
                  ></i>
                </span>
                <span style="margin-right: 1px; ">
                  <span v-if="!expand">AC</span>
                  <span v-else>TOT </span></span
                >
                <span v-if="total > 0" style="color: white; ">
                  | {{ total }}</span
                >
              </div>
            </div>
          </th>

          <th style="padding-right: 0">
            <div
                class="searchbox"
            >
              <input class="searchbox-input" type="text">
            </div>
            <div
              style="display: flex; align-items: flex-start; justify-content: flex-end;"
            >
              <div
                  class=" table-title"
                  :class="{ active: lastSort === 'alpha' }"
              >
                <span style="margin-right: 3px; cursor: pointer; ">
                  <i
                      class="fa fas fa-sort-alpha-down"
                      @click="applyAlphaSorting"
                  ></i>
                </span>
                {{
                  sizeIt(
                      selectedTab === "assignments"
                          ? "ASSIGN"
                          : selectedTab.toUpperCase()
                  )
                }}
              </div>
<!--kobi-->


              <div style="display: flex; max-width: 50px">
                <label class="mainCheckAll" for="check-all">
                  <input id="check-all" v-model="selectAll" type="checkbox" />
                </label>
                <h6 class="stats-types-button" @click="changeStatsView()">
                  {{ checkType() }}
                </h6>
              </div>
            </div>
          </th>
        </tr>
      </thead>
    </table>

    <div class="main-table">
      <div v-if="loading && statsOptions.length < 1 " class="loading-row">
        <div class="loader-report">
          Generating Report - Please wait

          <img
            src="../../../../../../../../src/assets/svg_icons/loading_bars.svg"
          />
        </div>
      </div>
      <table
        v-if="!loading && statsOptions.length > 0 || (sector === 'transfer' && selectedTab === 'dir')"
        class="table table-striped bottom-table"
      >
        <!--      fake thead for customize sizes-->
        <thead style="opacity:0%" class=" fake-thead">
          <tr
            :class="{
              forQuest:
                sector === 'questions' ||
                sector === 'sms' ||
                sector === 'questions_status',
              forCampaign: selectedTab === 'campaign'
            }"
            class="table-row-main table-title fake-thead"
          >
            <th
              v-for="key in Object.keys(typeOfKeys)"
              v-if="checkForFilters(key)"
              :key="key"
              class="fake-thead"
            >
              <div class="table-title fake-thead" style="max-height: 0px"></div>
            </th>

            <th class="fake-thead">
              <div class="table-title fake-thead"></div>
            </th>

            <th style="padding-right: 0; min-width: 155px" class=" fake-thead">
              <div
                style="display: flex; align-items: flex-start; justify-content: flex-end;"
                class=" fake-thead"
              >
                <div class=" table-title  fake-thead"></div>
                <div style="display: flex; max-width: 50px" class="fake-thead">
                  <label class="mainCheckAll fake-thead" for="check-all">
                    <!--                <input id="check-alln" v-model="selectAll" type="checkbox" class="fake-thead"/>-->
                  </label>
                  <h6 class="stats-types-button fake-thead"></h6>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <!--      end fake thead for customize sizes-->

        <tbody>
          <tr v-for="(opt, idx) in dataSet()" :key="idx" class="table-row-main">

            <td
              class="table-td"
              v-for="key in Object.keys(typeOfKeys)"
              v-if="
                (opt.expansion !== undefined &&
                  opt.expansion[key] !== undefined) ||
                  key === 'total'
              "
              :key="key"
            >
              {{ checkKey(opt.expansion[key]) }}
            </td>

            <td class="table-td">
              <multi-select-stats-numbers
                :sector="sector"
                :stats="
                  opt.hasOwnProperty('expansion')
                    ? opt.expansion.total.count
                    : opt.count
                "
                :total="total"
                :stats-view-type="statsViewType"
                :selected-tab="selectedTab"
                :expansion-data="expansionData"
              ></multi-select-stats-numbers>
            </td>
            <!--       <div>-->
            <td class="label-td" style="text-align: right">
              <label
                :for="opt.id"
                class="multi-check-label"
                style="margin-bottom: 1px;"
                :style="{'background-color' : background.color,
                  'text-decoration':exclude && isInSelected(opt.id)?'line-through':'none'}"
              >
                {{
                  opt.title.length > 15 ? opt.title.substring(0, 15) : opt.title
                }}
                <input
                  :id="opt.id"
                  v-model="selectedItems"
                  :type="
                    sector === 'transfer' && selectedTab === 'dir'
                      ? 'radio'
                      : 'checkbox'
                  "
                  :value="
                    sector === 'transfer' && selectedTab === 'dir'
                      ? [{ id: opt.id }]
                      : { id: opt.id }
                  "
                  @click="
                    sector === 'transfer' && selectedTab === 'dir'
                      ? (selectedTransDirection = { id: opt.id })
                      : ''
                  "
                  class="multi-check"
                />
              </label>
              <!--          </td>-->
              <!--          <td class="table-td row-number" style="font-size: 9px;">-->
              <span class="row-number" style="font-size: 9px;"
                ><span> #{{ idx + 1 }}</span></span
              >
            </td>

            <!--       </div>-->
          </tr>
        </tbody>
      </table>
    </div>
    <multi-select-graph-container
      v-show="sector === 'countries'"
      class="main-graph"
      :sector="sector"
      :sub-sector="selectedTab"
      :sorted-by="lastSort"
      :data="dataSet()"
      @timeFrame="emitTimeFrame"
    />
  </div>
</template>

<script>
import MultiSelectStatsNumbers from "./StatsNumbers";
import leads from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ld/leads";
import assignments from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/assignments/assignments";
import call_again from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ca/call_again";
import deposits from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/dp/deposits";
import transfer from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/tr/transfer";
import countries from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/countries/countries";
import sms from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/sms/sms";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import referral from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/referral/referral";
import no_answer from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/no_answer/no_answer";

import multiSelectGraphContainer from "./graphs/multiSelectGraph.container";
export default {
  name: "CheckBox.component",
  components: { MultiSelectStatsNumbers, multiSelectGraphContainer },
  props: {
    exclude:{
      type: Boolean
    },
    expand: {
      type: Boolean
    },
    background: {
      type: Object
    },
    expansionData: {
      type: Array,
      default: () => []
    },
    statsViewType: {
      type: Number
    },
    totalCount: {
      type: Array,
      default: () => []
    },
    noData: {
      type: Boolean,
      default: false
    },
    expandToRight: {
      type: Boolean,
      default: false
    },
    changedTab: {
      type: Boolean,
      default: false
    },

    selectedMainTab: {
      type: String
    },

    queryObject: {
      type: Object
    },
    mainTableReset: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number
    },
    resetMultiselect: {
      type: Boolean
    },
    show: {
      type: Boolean
    },
    //alphaSort: {
    //   type: String
    // },
    // amountSort: {
    //   type: String,
    //   required: true
    // },
    sector: {
      type: String
    },
    selectedTab: {
      type: String
    },
    statsOptions: {
      type: Array,
      default: () => []
    },
    searchResults: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean
    },
    showExtMultiSelect: {
      type: Boolean
    },
    checkAll: {
      type: Boolean
    },
    pageNum: {
      type: Number,
      default: 0
    },
    hasTabs: {
      type: Boolean
    }
  },
  mixins: [
    UsersPermissionCheck,
    leads,
    assignments,
    call_again,
    deposits,
    transfer,
    countries,
    sms,
    referral,
    no_answer
  ],

  data() {
    return {

      lastSort: null,
      alphaSort: "asc",
      amountSort: "asc",
      selectAll: false,
      initSecData: {},
      viewTypes: 1,
      sortedData: [],
      selectedItems: [],
      sectorData: {},
      sortOrderAlpha: "",
      sortOrderAmount: "",
      tTotal: 0,
      tNi: 0,
      tBn: 0,
      tActive: 0,
      tEnded: 0,
      tMerged: 0,
      tNa: 0,
      t4Total: 0,
      totalByFilters: {},
      typeOfKeys: {
        active: "ACTIVE",
        ended: "END",
        bn: "BN",
        merged: "MR",
        na: "NR",
        ni: "NI",
        t4: "NU"
      },
      transDirection: [
        {
          id: 0,
          title: "Transfer To",
          count: []
        },
        {
          id: 1,
          title: "Transfer From",
          alias: "transfrom",
          count: []
        },
        {
          id: 2,
          title: "Transfer By",
          alias: "transby",
          count: []
        }
      ],
      selectedTransDirection: {
        id: 0,
        title: "Transfer To",
        alias: "transto",
        count: []
      },
      transferDirectionDefaultType: 0
    };
  },

  mounted() {
    ///todo; (possible) preparation for sending data to charts
    // if(this.hasTabs){
    //   let initialSecData = {}
    //   let aliases = this[this.sector].map(s => s.alias)
    //   aliases.forEach(tab => {
    //     let lc = tab.toLowerCase()
    //     initialSecData[lc] = []
    //   })
    //
    //   this.initSecData = initialSecData
    //
    // }
  },

  methods: {
    isInSelected(id){
      return (this.selectedItems.some(selectedItem => selectedItem.id === id)) // if selectedItems.id contains id
    },
    emitTimeFrame(val) {
      this.$emit("timeFrame", val);
    },
    checkKey(data) {
      if (data.hasOwnProperty("count")) {
        return data.count[0];
      } else {
        return data[0];
      }
    },
    sizeIt(sentence) {
      if (sentence.length > 9) {
        return sentence.substr(0, 8);
      } else {
        return sentence;
      }
    },
    getTotalRow(row) {
      if (row.hasOwnProperty("total")) {
        return row.total.count[0];
      }
      let keys = Object.keys(row);
      let count = 0;
      keys.map(key => {
        count += row[key].count[0];
      });
      return count;
    },
    sort(col, place = 0, moreThenOne = false) {
      if (col !== this.lastSort) {
        this.amountSort = "desc";
      }
      this.lastSort = col;
      let idx;
      if (moreThenOne) {
        if (place === 0) {
          idx = 3;
        }
        if (place === 1) {
          idx = 2;
        }
        if (place === 2) {
          idx = 1;
        }
        if (place === 3) {
          idx = 0;
        }
      }
      if (!moreThenOne) {
        idx = 0;
      }

      let orig = this.dataSet();
      if (orig.length > 0 && orig[0].hasOwnProperty("expansion")) {
        if (this.amountSort.toString() === "desc") {
          let flattedArray = orig;
          flattedArray = flattedArray.sort((a, b) => {
            if (a.expansion[col].count[0] > b.expansion[col].count[0]) {
              return -1;
            }
            if (a.expansion[col].count[0] < b.expansion[col].count[0]) {
              return 1;
            }
            return 0;
          });
          this.amountSort = "asc";

          return (this.sortedData = flattedArray);
        }

        if (this.amountSort.toString() === "asc") {
          let flattedArray = orig;
          flattedArray = flattedArray.sort((a, b) => {
            if (a.expansion[col].count[0] < b.expansion[col].count[0]) {
              return -1;
            }
            if (a.expansion[col].count[0] > b.expansion[col].count[0]) {
              return 1;
            }
            return 0;
          });
          this.amountSort = "desc";
          return (this.sortedData = flattedArray);
        }
      }
    },

    sortByTot(cond) {
      if (this.lastSort) {
        this.amountSort = "desc";
      }
      this.lastSort = null;
      let orig = this.dataSet();
      if (orig.length > 0 && orig[0].hasOwnProperty("expansion")) {
        if (this.amountSort.toString() === "desc") {
          let flattedArray = orig;
          flattedArray = flattedArray.sort((a, b) => {
            if (a.expansion["total"].count[0] > b.expansion["total"].count[0]) {
              return -1;
            }
            if (a.expansion["total"].count[0] < b.expansion["total"].count[0]) {
              return 1;
            }
            return 0;
          });
          this.amountSort = "asc";

          return (this.sortedData = flattedArray);
        }

        if (this.amountSort.toString() === "asc") {
          let flattedArray = orig;
          flattedArray = flattedArray.sort((a, b) => {
            if (a.expansion["total"].count[0] < b.expansion["total"].count[0]) {
              return -1;
            }
            if (a.expansion["total"].count[0] > b.expansion["total"].count[0]) {
              return 1;
            }
            return 0;
          });
          this.amountSort = "desc";
          return (this.sortedData = flattedArray);
        }
      }

      if (orig.length > 0 && !orig[0].hasOwnProperty("expansion")) {
        if (this.amountSort.toString() === "desc") {
          let flattedArray = orig;
          flattedArray = flattedArray.sort((a, b) => {
            if (a.count[0] > b.count[0]) {
              return -1;
            }
            if (a.count[0] < b.count[0]) {
              return 1;
            }
            return 0;
          });
          this.amountSort = "asc";

          return (this.sortedData = flattedArray);
        }

        if (this.amountSort.toString() === "asc") {
          let flattedArray = orig;
          flattedArray = flattedArray.sort((a, b) => {
            if (a.count[0] < b.count[0]) {
              return -1;
            }
            if (a.count[0] > b.count[0]) {
              return 1;
            }
            return 0;
          });
          this.amountSort = "desc";
          return (this.sortedData = flattedArray);
        }
      }
    },
    sumTotalTitles(key) {
      //key= 'ended'
      ///checkKey(opt.expansion[key])
      let count = 0;
      const cost = this.expansionData.reduce((a, b) => {
        return a + b.expansion[key].count[0];
      }, count);
      return cost;
      // ALL in TH
      // if (this.searchResults.length > 0) {
      //   return this.searchResults;
      // }
      // if (this.sector === "transfer" && this.selectedTab === "dir") {
      //   return this.paginate(this.transDirection);
      // }
      // if (this.expansionData.length > 0 && this.show) {
      //   return this.expansionData;
      // }
      //
      // if (this.sortedData.length > 0) {
      //   return this.sortedData;
      // } else {
      //   return this.statsOptions;
      // }

      // const cost = this.keywordFullStats.reduce((a, b) => ({
      //   total_cost: a.total_cost + b.total_cost
      // }));
      //
      // const count = this.keywordFullStats.reduce((a, b) => ({
      //   total: a.total + b.total
      // }));
      // return {
      //   cost_total: cost.total_cost
      //           .toString()
      //           .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      //   /*percent_total: percent.total_percent.toFixed(0),*/
      //   count_total: count.total
      //           .toString()
      //           .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      //  };
    },

    calcTotals(data) {
      if (data.length > 0) {
        let keys = Object.keys(data[0].expansion);
        let totObject = {
          active: [],
          bn: [],
          ended: [],
          merged: [],
          na: [],
          ni: [],
          total: [],
          t4: []
        };
        data[0].map(i => {
          keys.map(key => {
            totObject[key].push(i.expansion[key].count[0]);
          });
        });
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;

        Object.keys(totObject).map(key => {
          if (totObject[key].length > 0) {
            this.totalByFilters[key] = totObject[key].reduce(reducer);
          }
        });
        this.expansionData = data;
        this.$emit("expansionDataReceived", this.expansionData);
      }
    },

    searchFilter(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              // The last word - ok with the word being "startswith"-like
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              // Not the last word - expect the whole word exactly
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.expansionData[this.pageNum].filter(item => {
        return searchRegex.test(item.title);
      });
    },

    checkForFilters(key) {
      if (this.expansionData.length > 0) {
        return (
          (this.expansionData.length > 0 ||
            this.expansionSearchResults.length > 0) &&
          this.expansionData[0].hasOwnProperty("expansion") &&
          this.expansionData[0].expansion.hasOwnProperty(key)
        );
      }
    },
    checkType() {
      if (this.viewTypes === 1) {
        return "C";
      }
      if (this.viewTypes === 2) {
        return "%";
      }
      if (this.viewTypes === 3) {
        return "A";
      }
    },
    changeStatsView() {
      this.$emit("changeStatsView", this.viewTypes + 1);
      this.viewTypes++;
      if (this.viewTypes > 3) {
        this.viewTypes = 1;
        this.$emit("changeStatsView", this.viewTypes);
      }
    },
    getTotal(data) {
      if (data.length > 0) {
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        return data
          .map(s => s)
          .flat(Infinity)
          .reduce(reducer);
      }
    },
    getTotalCount(idx) {
      if (this.totalCount.length > 0) {
        return this.totalCount[idx];
      }
    },
    paginate(stats) {
      let pageSize = 10;

      let inputArray = stats;

      let result = inputArray.reduce((resultArray, item, index) => {
        const pageIndex = Math.floor(index / pageSize);

        if (!resultArray[pageIndex]) {
          resultArray[pageIndex] = []; // start a new page
        }

        resultArray[pageIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    placeDot(index) {
      if (index === 0) {
        return "red-dot";
      }
      if (index === 1) {
        return "yellow-dot";
      }
      if (index === 2) {
        return "green-dot";
      }
    },
    applyAlphaSorting() {
      this.lastSort = "alpha";
      if (this.alphaSort.toString() === "asc") {
        this.alphaSort = "desc";
        let orig = this.dataSet();
        let flattedArray = orig.flat(Infinity);
        this.sortedData = flattedArray.sort((a, b) => {
          if (a.title > b.title) {
            return -1;
          }
          if (a.title < b.title) {
            return 1;
          }
          return 0;
        });

        return this.sortedData;
      }

      if (this.alphaSort.toString() === "desc") {
        this.alphaSort = "asc";

        let orig = this.dataSet();
        let flattedArray = orig.flat(Infinity);
        this.sortedData = flattedArray.sort((a, b) => {
          if (a.title < b.title) {
            return -1;
          }
          if (a.title > b.title) {
            return 1;
          }
          return 0;
        });

        return this.sortedData;
      }
    },

    applyAmountSorting(col, place = 0, moreThenOne = false) {
      let idx;

      if (moreThenOne) {
        if (place === 0) {
          idx = 3;
        }
        if (place === 1) {
          idx = 2;
        }
        if (place === 2) {
          idx = 1;
        }
        if (place === 3) {
          idx = 0;
        }
      }
      if (!moreThenOne) {
        idx = 0;
      }

      if (this.amountSort.toString() === "desc") {
        let orig = this.dataSet();
        let flattedArray = orig.flat(Infinity);
        this.sortedData = flattedArray.sort((a, b) => {
          if (a.count[idx] > b.count[idx]) {
            return -1;
          }
          if (a.count[idx] < b.count[idx]) {
            return 1;
          }
          return 0;
        });
        return this.sortedData;
      }

      if (this.amountSort.toString() === "asc") {
        let orig = this.dataSet();
        let flattedArray = orig.flat(Infinity);
        this.sortedData = flattedArray.sort((a, b) => {
          if (a.count[idx] < b.count[idx]) {
            return -1;
          }
          if (a.count[idx] > b.count[idx]) {
            return 1;
          }
          return 0;
        });
        return this.sortedData;
      }
    },

    setSortButtons() {
      if (this.statsOptions.length > 0) {
        return this.statsOptions[0].count.length;
      } else {
        return this.transDirection[0].count.length;
      }
    },

    dataSet() {
      if (this.sector === "transfer" && this.selectedTab === "dir") {
        return this.transDirection;
      }
      if (this.sortedData.length > 0) {
        return this.sortedData;
      }

      if (this.searchResults.length > 0) {
        return this.searchResults;
      }

      if (this.expansionData.length > 0 && this.show) {
        return this.expansionData;
      }
      return this.statsOptions;
    },
    resetAllData() {
      this.sortedData = [];
    }
  },

  watch: {
    expansionData() {
      this.resetAllData();
    },
    statsOptions() {
      this.resetAllData();
    },
    selectAll() {
      this.$emit("check_all", this.selectAll);
    },
    mainTableReset() {
      if (this.mainTableReset) {
        this.sectorData = {};
        this.selectedItems = [];
        this.$emit("reset_multiselect");
      }
    },
    selectedTab() {
      this.selectedItems = this.sectorData.hasOwnProperty(this.selectedTab)
        ? this.sectorData[this.selectedTab]
        : [];
      this.sortedData = [];
      this.dataSet();
    },
    sortedData() {
      this.dataSet();
    },
    alphaSort() {
      //this.applyAlphaSorting();
    },
    amountSort() {
      //this.applyAmountSorting();
    },
    selectedItems() {
      if (
        this.sectorData.hasOwnProperty(this.selectedTab) &&
        this.selectedItems.length === 0
      ) {
        //this.selectedItems = this.sectorData[this.selectedTab];
      }
      if (this.selectedItems.length > 0) {
        this.sectorData[this.selectedTab] = this.selectedItems;
        this.$emit("sectorData", this.sectorData);
        if (this.sector === "transfer" && this.selectedTab === "dir") {
          //this.selectedTransDirection = this.selectedItems;
        }
        if (this.sector === "transfer" && this.selectedTab !== "dir") {
          this.$emit("input", this.selectedItems);
        }
        if (this.sector !== "transfer" && this.selectedTab !== "dir") {
          this.$emit("input", this.selectedItems);
        }
      }
    },

    selectedTransDirection() {
      this.$emit("transDirection", this.selectedTransDirection);
    },
    resetMultiselect() {
      if (this.resetMultiselect) {
        this.selectedItems = [];
        this.sectorData = {};
        this.$emit("reset_multiselect");
      }
    },
    checkAll() {
      if (!this.checkAll) {
        let selected = [];
        this.statsOptions.forEach(item => {
          selected.push({ id: item.id });
        });
        this.selectedItems = selected;
      }
      if (this.checkAll) {
        this.sectorData[this.selectedTab] = [];
        this.selectedItems = [];
      }
    }
  }
};
</script>

<style scoped>

.inner {
  /*height: 170px;*/
  max-height: 450px;
  overflow-x: hidden;
  margin-right: -3px;
  overflow-y: hidden;
  min-width: 410px;
}
.innerDep {
  max-height: 450px;
  overflow-x: hidden;
  margin-right: -3px;
  overflow-y: hidden;
  min-width: 670px;
}

.multi-check-label {
  /*display: block;*/
  /*padding-left: 0.3rem;*/
  /*margin-right: 0.2rem;*/
  /*margin-left: 1.5rem;*/
  /*text-indent: -15px;*/
  /*font-size: 12px;*/
  /*cursor: pointer;*/
  font-size: 12px;
}

.multi-check {
  width: 13px;
  height: 13px;
  padding: 0;
  margin-right: 3px;
  vertical-align: middle;
  position: relative;
  top: -3px;
  overflow: hidden;
}

.item-counter {
  font-size: 8pt;
  float: right;
  margin-right: 10px;
  text-align: left;
  direction: ltr;
  min-width: 20px;
}

.nav-tabs a {
  height: 20px;
  padding: 4px;
  font-size: 13px;
}

.nav-tabs li:hover {
  background: #83c3ec !important;
}

.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 2px solid;
  border-bottom-color: #1e88e5;
  font-size: 13px;
  color: #1e88e5;
}
.nav-tabs > li {
  float: right;
}
ul li:hover {
  background: #0d6aad;
}

.nav-tabs li {
  margin: 0;
}

.nav-tabs li:hover {
  background: none;
  margin: 0;
}

.sort-btn {
  padding: 3px;
  margin: 1px;
}

.green-dot {
  height: 10px;
  width: 10px;
  background-color: #64dd17;
  border-radius: 50%;
  display: inline-block;

  float: right;
  margin-top: 5px;
}

.yellow-dot {
  height: 10px;
  width: 10px;
  background-color: #ffd600;
  border-radius: 50%;
  display: inline-block;
  margin-top: 5px;
  float: right;
}

.red-dot {
  height: 10px;
  width: 10px;
  background-color: #d50000;
  border-radius: 50%;
  display: inline-block;
  margin-top: 5px;
  float: right;
}

.table-row-main {
  /*display: flex;*/
  /*align-items: center;*/
  /*min-height: 30px;*/
  /*max-height: 32.1px;*/
  /*justify-content: space-between;*/
  /*display: flex;*/
  /*justify-content: space-evenly;*/
  min-height: 3.22vh !important;
  max-height: 3.22vh !important;
  margin-bottom: 0.16vh !important;
}

.table-td {
  /*padding: 5px;*/
  border-top: 0;
}

.loader {
  /*position: absolute;*/
  top: 50%;
  right: 50%;
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem;
  padding: 3rem;
  border: none;
  background-color: #fff;
}
.table-row-main-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem;
  border-top: 0;
}
.inner::-webkit-scrollbar {
  display: none;
}

.active-checkbox-title-right {
  float: right;
  margin-right: 4px;
  margin-top: 3px;
  margin-bottom: 14px;
  font-weight: bold;
  font-size: 11px;
}

.row-number {
  max-width: 20px;
  min-width: 20px;
  font-size: 9px;
  float: right;
  padding-top: 5px;
}

.x-tag {
  padding: 0;
  font-size: 9px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  justify-content: flex-end;
}

.table-title {
  margin-right: 3px;
  min-width: 100px;
  max-width: 120px;
  text-align: center;
  font-size: 12px;
  border: 0.1vh solid white;
  border-radius: 14px;
  color: white;
  padding: 5px;
  align-self: flex-end;
}
.searchbox{
  border-radius: 14px;
  margin-right: 3px;
  font-size: 12px;
  color: #696969;
  padding: 5px;
  order:-1;
}
.searchbox-input{
  border-radius: 14px;
  border: 0.1vh solid green;
}

.table-title.active {
  border: 0.4vh solid #ffffff;
}

.expansion-hr {
  margin-top: -20px;
  border: 0;
  border-top: none;
}
.expansion-hr-camp {
  margin-top: -14px;
  border: 0;
  border-top: none;
}
.expansion-hr-right {
  margin-top: -20px;
  border: 0;
  border-top: none;
}

.active-checkbox-title {
  /*float: left;*/
  /*margin-left: 4px;*/
  /*margin-top: 3px;*/
  /*margin-bottom: 14px;*/
  /*font-weight: bold;*/
  /*font-size: 11px;*/
  margin-right: 5px;
  min-width: 120px;
  max-width: 120px;
  text-align: center;
  font-size: 11px;
  border: 2px solid white;
  border-radius: 14px;
  color: white;
  justify-content: center;
  display: flex;
  align-items: center;
  min-height: 30px;
  max-height: 30px;
}
.stats-types-button {
  /*min-width: 20px;*/
  /*max-width: 20px;*/
  /*border-radius: 6px;*/
  /*padding: 0;*/
  /*max-height: 20px;*/
  /*border: none;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  /*background: whitesmoke;*/
  /*margin-right: 7px;*/
  /*margin-top: 15px;*/
  top: 6px;
  min-width: 20px;
  max-width: 20px;
  position: relative;
  /*border-radius: 6px;*/
  padding: 0;
  max-height: 20px;
  border: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  /*background: whitesmoke;*/
  margin-right: 5px;
  color: white;
  /* margin-top: 15px; */
  cursor: pointer;
}
.stats-types-butto-ac {
  min-width: 20px;
  max-width: 20px;
  border-radius: 6px;
  padding: 0;
  max-height: 20px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background: whitesmoke;
  margin-right: 7px;
  margin-top: 14px;
}
.table-striped {
  /*margin-top: -9px !important;*/
}
.mainCheckAll {
  padding-top: 14px;
  margin: 0 5px;
}
.rightAlignment {
  margin-top: 13px !important;
}
.whitBgc {
  background-color: #fb9324 !important;
}
.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: white !important;
  /*min-height: 32.5px;*/
}
.table-striped > tbody > tr:nth-of-type(even) {
  background-color: #f9f9f9 !important;
  margin-bottom: 0.2px;
}
.table-row-main {
  table-layout: fixed;
}

.table-striped > tbody > .table-row:nth-last-child {
  /*min-height: 33px !important;*/
}
.main-table {
  max-height: 300px !important;
  overflow-y: auto;
  margin-bottom: 20px;
  margin-top: 0px;
}
.d-none-questions {
  display: none;
}
/*.check-all-assignments-open {*/
/*  height: 15px;*/
/*  !* font-size: 61px; *!*/
/*  position: absolute;*/
/*  width: 85px;*/
/*  left: -5px;*/
/*  top: 43px;*/
/*}*/
/*.check-all-assignments {*/
/*  height: 15px;*/
/*  !* font-size: 61px; *!*/
/*  position: absolute;*/
/*  width: 85px;*/
/*  right: -7px;*/
/*  top: 33px;*/
/*  !* left: 5px; *!*/
/*}*/
/*.active-checkbox-title-assignments-close {*/
/*  position: absolute;*/
/*  right: 44px;*/
/*  top: 11px;*/
/*  direction: ltr;*/
/*}*/
/*.active-checkbox-title-assignments-close-ac {*/
/*  position: absolute;*/
/*  left: 125px;*/
/*  top: 11px;*/
/*  direction: ltr;*/
/*}*/
/*.active-checkbox-title-assignments-open-ac {*/
/*  position: absolute;*/
/*  left: 48px;*/
/*  top: 11px;*/
/*  direction: ltr;*/
/*}*/
.main-ms-table {
  margin-top: 10px;
  margin-bottom: 0px;
}
.bottom-table {
  margin-top: 0px;
  margin-bottom: 0px;
}

.forQuest {
  background-color: grey;
}
.forCampaign {
  background-color: grey;
}
.root-body-countries table.table.table-striped.main-ms-table thead {
  background: grey !important;
}
.label-td {
  max-width: 120px !important;
}
.fake-thead {
  padding-top: 0px;
  padding-bottom: 0px;
  max-height: 0px !important;
}
th.fake-thead {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  max-height: 0px !important;
}
.table-row-main > th {
  border-bottom: 0px;
}
.loader-report > img {
  height: 40px;
}
.main-graph {
  background-color: #fff;
}
</style>
